// Yandex / UTM capture — canon Phase 4. Reads yclid + UTM from the URL (pseudonymous).
// Metrica ClientID is async (ym getClientID) — left undefined here so the SDK emits
// `yandex_id_unavailable`; wiring the async ym callback is a follow-up.
export interface YandexContext {
  utm: Record<string, string>;
  yclid?: string;
  metrica_client_id?: string;
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

export function captureYandex(): YandexContext {
  const params = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
  const utm: Record<string, string> = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) utm[key] = value;
  }
  const yclid = params.get('yclid') ?? undefined;
  return { utm, yclid };
}
